import cn from "classnames";

type DividerProps = {
    className?: string;
    color?: string;
};

const getColorClassnamesFromName = (color: string | undefined) => {
    if (color) {
        return `border-${color} text-${color}`;
    }

    return "border-gray-200 text-gray-200";
};

function Divider({ className, color }: DividerProps) {
    return (
        <div className={className}>
            <div className={cn("border-b", getColorClassnamesFromName(color))} />
        </div>
    );
}

export default Divider;
